module.exports = __webpack_public_path__ + "static/media/cbse2021.ebefe13e.jpeg";